import { callApi } from "../../../api/gramjs";
import { ApiChat, ApiMessage, MAIN_THREAD_ID } from "../../../api/types";
import { DEBUG } from "../../../config";
import { getActions, getGlobal } from "../../../global";
import { selectChat, selectCurrentMessageList } from "../../../global/selectors";
import { DBManager } from "../db/dbManager";
import { clearMessages } from "../redux/notiSlice";
import store from "../store";
import { LotMessage, TeleMessageToSend } from "../types/types";

import { dateToSeconds, secondsToDate } from "../utils/DateTimeUtils";
import { deleteHistory } from "../../../api/gramjs/methods";
import Parser from "../restapi/parser";

import { globalDexieDb } from "../db/DexiedbLib";
import { debounce } from "lodash";
import { sleep } from "../../../lib/gramjs/Helpers";
import { NativeRestApi } from "../websocket/nativeRestApi";
import worker from "../setupWorker";
import { Dexiedb } from "../db/Dexiedb";
import { GetUserFullInfo } from "../utils/common";
import { enumDauVaoTinNhan } from "../commontypes";
import { MessageList } from "../../../types";
import { userInfo } from "os";
import { wsClientInstance } from "../websocket/nativeapp";
import { MessageParseState, WireMessage, WSMessage } from "../websocket/wsTypes";
import Message from "../../middle/message/Message";
import { gotdapi } from "../restapi/gotd";
import { TelegramMessageRecord } from "../db/gotd";


const sliceSize = 100 // số lượng tin nhắn mỗi lần load từ 1 chatId
const dateStop = new Date()
let secondStop = dateToSeconds(dateStop) - 60 * 60 * 24 * 1000 // lùi lại 2 ngày

/*Hàm này hiện tại load tối đa 100 chat, sau phải viết lại để load toàn bộ chat*/
export async function GetChatIds() {
    const global = getGlobal()
    /* const result = await callApi('fetchChats', {
        limit: 1000,
        offsetDate: 0,
        archived: false,
        withPinned: false,
        lastLocalServiceMessage: undefined,
    });
    const { chatIds } = result;
    console.log("chatiDs:",chatIds) */
    const chatIds = global.chats.listIds.active;
    return chatIds;
}


async function GetMessagesByChat(chat: ApiChat, offsetId: number, addOffset: number) {
    const r = await callApi('fetchMessages', {
        chat: chat,
        offsetId: offsetId,
        addOffset: addOffset
        , limit: sliceSize,
        threadId: MAIN_THREAD_ID,
    })
    return r
}
/*Tải tin nhắn và đệ quy đến điều kiện STOP*/
export async function FetchMessagesByChatId(chatId: string,
    offsetId: number, addOffset: number, callDeQuy?: boolean) {
    /*Lần đầu gọi:
    offsetId=0 : lấy sliceSize tin từ tin cuối cùng gần nhất
    addOffset=-1 :không lấy id hiện tại, chỉ lấy tin sau hoặc trướcc id này
         0: lấy cả tin có id id= offsetId 
    */
    const global = getGlobal()
    let chat = selectChat(global, chatId)


    if (chat) {
        const firstResult = await GetMessagesByChat(chat, offsetId, addOffset)
        console.log("", firstResult)
        //
        if (firstResult) {
            const { messages } = firstResult;

            if (messages.length > 0) {
                const lastMessage = messages[0];
                const firstMessage = messages[messages.length - 1];
                //store.dispatch(addMessageToStore({ messages: messages, chatId: chatId }))
                if (firstMessage.date < secondStop) {
                    // ngày của tin nhắn nhỏ hơn ngày lấy thì stop
                    console.log("Kiểm tra không cần gọi đệ quy do ngày nhỏ hơn ngày hạn chế")
                } else {
                    if (callDeQuy) {
                        const time = setTimeout(() => {
                            FetchMessagesByChatId(firstMessage.chatId, firstMessage.id, 0, callDeQuy)
                            console.log(`FetMessagesByChatId(${firstMessage.chatId},${firstMessage.id},0,${callDeQuy})`)
                            clearTimeout(time)
                        }, 500)

                    } else {
                        console.log("Không gọi đệ quy")
                    }
                }
            } else {
                console.log("Dừng đệ quy do không còn tin nhắn")
            }
        }
        return firstResult;
    }
    else
        return undefined
    return;
}
/*Tải 1 lần toàn bộ tin nhắn từ telegram*/
export async function FetchAllMessages(callDeQuy: boolean) {
    const chatIds: string[] | undefined = await GetChatIds()
    const global = getGlobal()
    if (chatIds) {
        console.log(`Bắt đầu đọc tin nhắn`)
        const startTime = new Date()
        for (let i = 0; i < chatIds.length; i++) {
            const chatId: string = chatIds[i];
            let offsetId = 0
            let addOffset = -1
            const state = store.getState().tdlibSlice
            const lastFetch: any | undefined = state.messagesResult[chatId]
            let fetch = true
            if (lastFetch) {
                addOffset = 0
                offsetId = lastFetch[lastFetch.length - 1].id
                fetch = lastFetch[lastFetch.length - 1].date > secondStop
            }
            if (fetch) {
                const msgs = await FetchMessagesByChatId(chatId, offsetId, addOffset, callDeQuy);
                console.log(`chatId:${chatId}. messages=`, msgs)
            } else {
                console.log(`chatId:${chatId}. Khong call do tin nhắn đã load có thời gian nhỏ hơn thời gian hạn chế `)
            }
        }
        const endTime = new Date()
        const soGiay = endTime.getTime() - startTime.getTime()
        console.log(`Đọc xong toàn bộ tin nhắn: ${soGiay / 1000}s `)
    }
}
export async function FetchAllChatAndSaveToLocal() {
    const chatIds = await GetChatIds()
    const global = getGlobal()
    const db = await DBManager.getDBConnection()
    const trans = db.transaction(["chats"], "readwrite")
    const chats = trans.objectStore("chats")
    chatIds?.map((chatId: string) => {
        const chat = selectChat(global, chatId)
        chats.put(chat)
    })
    trans.commit()
}
/*Load toàn bộ chat lưu vào db 
gọi lần đầu, lưu 100 tin nhắn mới nhất của mỗi chat*/
export async function FetchAllMessageAndSaveToLocal() {
    const chatIds = await GetChatIds()
    const global = getGlobal()
    const db = await DBManager.getDBConnection()


    const promises: any[] = [];
    const startTime = new Date()
    let i = 1;
    let count = chatIds?.length
    chatIds?.map((chatId: string) => {
        const chat = selectChat(global, chatId)
        const promise = new Promise((resolve, reject) => {
            FetchMessagesByChatId(chatId, 0, -1, false).then(async (msgs: any) => {
                try {
                    // đã lưu ở module message.ts khi fetchMessages, ở đây lưu khi đồng bộ


                    if (msgs && msgs.messages && msgs.messages.length > 0) {
                        // Chuyển map() thành for...of với `Promise.all()`

                        for (const msg of msgs.messages) {
                            const mergeMessage = await mergeTelemessage(msg);
                            const transMsgs = db.transaction(["messages"], "readwrite")
                            const messages = transMsgs.objectStore("messages")
                            messages.put(mergeMessage)
                        }




                    }
                    else {
                        if (DEBUG)
                            console.log("Kết quả trả về không đúng cấu trúc:", msgs, chat)
                    }
                    // await transMsgs.commit()
                    //store.dispatch(updateNotiMessage({ message: `Đang đồng bộ hội thoại:${i}/${count}` }))
                }
                catch (e) {
                    console.error(e);
                }
                i++
                resolve(1);
            })
        })
        promises.push(promise)
    })
    //await Promise.all(promises);
    let countPromise = 0
    for (const promise of promises) {
        const ms = 200
        await promise;
        countPromise++;
        // if (countPromise % 40 == 0){
        //     console.log(`chờ sau ${30000} ms mới thực hiện tiếp`)
        //     await new Promise(resolve => setTimeout(resolve, 30000)); // Chờ 30 giây say mới đồng bộ tiếp ms
        // }           
        // else
        {
            console.log(`chờ sau ${ms} ms mới thực hiện tiếp`)
            await new Promise(resolve => setTimeout(resolve, ms)); // Chờ 100 ms
        }

        if (DEBUG)
            console.log(`Thực hiện tiếp vòng lặp sau`)
    }
    const endTime = new Date()
    const soGiay = endTime.getTime() - startTime.getTime()
    //console.log(`Đọc xong toàn bộ tin nhắn: ${soGiay / 1000}s `)
    //store.dispatch(updateNotiMessage({ message: `Đã đồng bộ xong tin nhắn:${soGiay / 1000}s` }))
    const timer = setTimeout(() => {
        store.dispatch(clearMessages({}))
        if (DEBUG)
            console.log(`Đọc xong toàn bộ tin nhắn: ${soGiay / 1000}s `)
        clearTimeout(timer)
    }, 5000)
    //transMsgs.commit()
}
/*Nạp tin nhắn lên để phân tích
messageType=0: lấy hết inbox và outbox
1: inbox
2 outbox
parseStatus:0 chưa phân tích, 1 : đã phân tích, 2: all
*/
export async function GetAllMesssagesForParse(messageType: number, parseStatus: number): Promise<LotMessage[]> {
    const userFullInfo = GetUserFullInfo()
    if (userFullInfo.suDungTinBot == enumDauVaoTinNhan.android) { //1 là android
        return GetAllMesssagesForParseAndroid(messageType, parseStatus)
    } else if (userFullInfo.suDungTinBot == enumDauVaoTinNhan.telegramweb) { //0 là teleweb
        return GetAllMesssagesForParseTeleWeb(messageType, parseStatus)
    } else if (userFullInfo.suDungTinBot == enumDauVaoTinNhan.bot) { //2 là tin bot   
        return GetAllMesssagesForParseTeleWeb(messageType, parseStatus)
    } else if (userFullInfo.suDungTinBot == enumDauVaoTinNhan.telegram) { //3 là tin tele trực tiếp
        return GetAllMesssagesForParseTele(messageType, parseStatus)
    }
    return []
}
// trước khi lưu tin đồng bộ từ tele, đọc local xem có tin chưa
//nếu có rồi thì copy 1 số thuộc tính sang
export async function mergeTelemessage(message: any): Promise<any> {
    const result = { ...message }
    const msg = await Dexiedb.instance.messages.where('[chatId+id]').equals([message.chatId, message.id]).first();
    if (msg) {
        result['isAutoParse'] = msg['isAutoParse'] ? msg['isAutoParse'] : false;
        result['parsed'] = msg['parsed'] ? msg['parsed'] : false;
        if (DEBUG && msg['parsed']) {
            console.log(`giá trị cũ parsed đã copy vào:`, result['parsed']);
        }
        if (DEBUG && msg['isAutoParse']) {
            console.log(`giá trị cũ isAutoParse đã copy vào:`, result['isAutoParse']);
        }
    }
    if (DEBUG)
        console.log('mergeTelemessage:', result);
    return result;
}
/*tin android, nếu ko phải tin tele thì giả lập chatId*/
async function GetChatIdOfAndroidMsg(msg: any): Promise<number> {
    let result = 0
    if (msg.TLChatID == 0) {
        result = await GetPhoneFromAddress(msg.address)
    } else {
        result = msg.TLChatID
    }
    if (isNaN(result)) {
        //console.log('address là 1 xâu ký tự, cần tìm tên trong danh bạ để so khớp', msg.address)
        worker.postMessage({ type: 'showsnackbar', data: `Không tìm thấy tên trong danh bạ:${msg.address}` })
        //throw 'Không thể chuyển đổi phone thành SỐ'
    }
    return result
}
function GetTlMessageIdOfAndroidMsg(msg: any): number {
    let result = 0
    if (msg.TLmessageId == 0) {
        result = msg.contentId
    } else {
        result = msg.TLmessageId
    }
    return result
}
/*address phải là kiểu số, các hội thoại quảng cáo có address kiểu VIETTEL_MONEY sẽ ko đọc vào */
async function GetPhoneFromAddress(phone: string): Promise<number> {
    let p = phone.replace(" ", "")
    if (p.startsWith("+84")) {
        p = "0" + p.substring(3)
    } else if (p.startsWith("84")) {
        p = "0" + p.substring(2)
    }
    let result = Number(p)
    if (isNaN(result)) {
        result = await GetChatIdByName(phone)
    }
    return result
}
/*Dùng trong trường hợp không có số phone, chỉ có tên ví dụ : BIDV, VIETTEL*/
async function GetChatIdByName(name: string): Promise<number> {
    let result = NaN
    const ct = await globalDexieDb.contacts.where("name").equals(name).first()
    if (ct) {
        result = ct.tlUserId!
    }
    return result
}
export async function MapAndroidMsgToLotMessage(msg: any): Promise<LotMessage | null> {
    const tmp = msg;
    const chatId = await GetChatIdOfAndroidMsg(msg)
    if (isNaN(chatId)) {
        return null
    }
    const tlMessageId = GetTlMessageIdOfAndroidMsg(msg)
    const lmsg: LotMessage = {
        tlChatId: chatId,
        tlMessageId: msg.contentId,
        contactId: -1, //điền sau, dựa vào các tham số khác
        tlSenderId: chatId,
        body: msg.body,
        bodyOrigin: msg.body,
        date: secondsToDate(msg.date / 1000),
        type: (msg.boxId == 1) ? 1 : 2,
        htmlError: msg.body,
        errorText: "Chưa phân tích",
        tlChatTitle: await GetContactNameFromIndexDB(msg)
    }
    return lmsg;
}
async function GetChatTitleFromMessage(msg: any): Promise<string> {

    const chatId = await GetChatIdOfAndroidMsg(msg)
    let result = `${chatId}`
    const userSend = msg.userSend.trim()
    if (userSend != "" && msg.boxId == 1) {
        result = userSend
    } else {
        console.log(msg)
    }
    return result
}
function ToLocalPhone(phone: string): string {
    if (phone.startsWith("+84")) {
        phone = "0" + phone.substring(3)
    }
    if (phone.startsWith("84")) {
        phone = "0" + phone.substring(2)
    }
    return phone
}
async function GetContactNameFromIndexDB(msg: any): Promise<string> {
    let result = ""
    const phone = ToLocalPhone(msg.address)
    const phoneInNum = Number(phone)
    if (isNaN(phoneInNum)) {
        return phone
    }
    let contact = await globalDexieDb.contacts.where('phone').equals(phone).first()
    if (contact == undefined) {
        contact = await globalDexieDb.contacts.where('tlUserId').equals(Number(phone)).first()
    }
    if (contact) {
        result = contact!.name!
    }
    if (result == "") {
        result = await GetChatTitleFromMessage(msg)
    }
    return result
}
export async function GetAllMesssagesByIdsAndroid(ids: any[]): Promise<LotMessage[]> {
    let result: LotMessage[] = [];
    const promises: Promise<LotMessage[]>[] = []
    for (let id of ids) {
        const promise = new Promise<LotMessage[]>((resolve, reject) => {
            NativeRestApi.getAllMessagesByConv(id).then(async (res) => {
                if (res && res.message) {
                    const data = JSON.parse(res.message)
                    for (let m of data) {
                        const tmp = await MapAndroidMsgToLotMessage(m)
                        if (tmp != null)
                            result.push(tmp)
                    }
                    resolve(result)
                } else {
                    reject()
                }
            })
        })
        promises.push(promise)
    }
    await Promise.all(promises)
    return result
}
export async function GetAllMesssagesByChatIdTeleWeb(messageType: number, parseStatus: number): Promise<LotMessage[]> {
    const promise = new Promise<LotMessage[]>((resolve, reject) => {

        resolve(1)


    })
    await promise
    return promise;
}
export async function GetAllMesssagesForParseAndroid(messageType: number, parseStatus: number): Promise<LotMessage[]> {
    let result: LotMessage[] = [];
    const promise = new Promise<LotMessage[]>((resolve, reject) => {
        NativeRestApi.getAllMessages().then(async (res) => {
            if (res && res.message) {
                const messages = JSON.parse(res.message)
                for (let msg of messages) {
                    //const num = Number(msg.address)
                    // address là số thì mới đọc vào
                    if (/* !isNaN(num) && */ (msg.boxId == 1 && messageType == 1 || msg.boxId != 1 && messageType != 1)) {
                        const tmp = await MapAndroidMsgToLotMessage(msg)
                        if (tmp != null)
                            result.push(tmp)
                    }
                }
                resolve(result)
            } else {
                reject(1)
            }
        })
    })
    await promise
    return result
}
export async function GetAllMesssagesForParseTeleWeb(messageType: number, parseStatus: number): Promise<LotMessage[]> {
    let get = true
    let result: LotMessage[] = [];
    const db = await DBManager.getDBConnection()
    const trans = db.transaction("messages")
    const messagesStore = trans.objectStore("messages")
    const getRequest = messagesStore.getAll()
    const global = getGlobal()
    const mapChatIdId: Map<string, LotMessage | any> = new Map()
    // Tạo một Promise để xử lý việc trả về
    const promise = new Promise<LotMessage[]>((resolve, reject) => {
        getRequest.onsuccess = () => {
            const existingMessages = getRequest.result;

            existingMessages.forEach((item: ApiMessage) => {
                const key = item.chatId + "." + item.id
                mapChatIdId.set(key, item)
                if (item.content) {
                    if (item.content.text) {
                        const chat = selectChat(global, item.chatId)
                        const text = item.content.text.text.toLowerCase()
                        if (messageType != undefined) {
                            if (messageType == 2)
                                get = item.isOutgoing
                            else if (messageType == 1)
                                get = !item.isOutgoing
                        }
                        if (get) {
                            const lmsg: LotMessage = {
                                tlChatId: Number(item.chatId),
                                tlMessageId: item.id,
                                contactId: -1, //điền sau, dựa vào các tham số khác
                                tlSenderId: Number(item.senderId),
                                body: text,
                                bodyOrigin: item.content.text.text,
                                date: secondsToDate(item.date),
                                type: item.isOutgoing ? 2 : 1,
                                htmlError: text,
                                errorText: "Chưa phân tích",
                                tlChatTitle: chat?.title.toLowerCase()
                            }

                            if (parseStatus == 0 || parseStatus == 1) {
                                if (parseStatus == 0) {
                                    if (item.parsed != true || item.parsed == undefined)
                                        result.push(lmsg)
                                }
                                if (parseStatus == 1) {
                                    if (item.parsed)
                                        result.push(lmsg)
                                }

                            } else {
                                result.push(lmsg) // lấy tất
                            }
                        }
                    }
                }

            });

            // Giải phóng Promise khi đã xử lý xong
            resolve(result);
        };

        getRequest.onerror = () => {
            console.log("getRequest error");
            // Giải phóng Promise khi có lỗi
            reject("getRequest error");
        };
    });
    await promise
    // nạp thêm các tin nhắn trong global để đảm bảo các tin nhắn mới nhất được xử lý
    // vì khi tin nhắn đến, lưu vào indexDb chưa xong

    const chatIds = Object.keys(global.messages.byChatId)
    chatIds.map(chatId => {
        const chatMsgs = global.messages.byChatId[chatId]
        const ids = Object.keys(chatMsgs.byId)
        if (DEBUG)
            console.log(`${chatId} count messages:${ids.length} `)
        ids.map((id) => {
            const key = chatId + "." + id
            if (mapChatIdId.get(key) == undefined) {
                const item = chatMsgs.byId[Number(id)]
                if (item.chatId == '777000') {
                    //không làm gì cả 
                } else {
                    if (item.content) {
                        if (item.content.text) {
                            const chat = selectChat(global, item.chatId)
                            const text = item.content.text.text.toLowerCase()
                            const lmsg: LotMessage = {
                                tlChatId: Number(item.chatId),
                                tlMessageId: item.id,
                                contactId: -1, //điền sau, dựa vào các tham số khác
                                tlSenderId: Number(item.senderId),
                                body: text,
                                bodyOrigin: item.content.text.text,
                                date: secondsToDate(item.date),
                                type: item.isOutgoing ? 2 : 1,
                                htmlError: text,
                                errorText: "Chưa phân tích",
                                tlChatTitle: chat?.title.toLowerCase()
                            }
                            result.push(lmsg)
                            //store.dispatch(addNewMessageToStore({ newMessage: item }))
                            if (DEBUG)
                                console.log(`tin nhắn có trong global nhưng không có trong index, add thêm ${item.id}`)
                        }
                    }
                }

            }
        })
    })

    return promise;
}
export async function GetAllMesssagesForParseTele(messageType: number, parseStatus: number): Promise<LotMessage[]> {
    const targetDate = new Date();
    const start = Math.floor(targetDate.setHours(0, 0, 0, 0) / 1000); // UNIX giây
    const end = Math.floor(targetDate.setHours(23, 59, 59, 999) / 1000);
    const byDate = await globalDexieDb.telegramMessage
        // .where('date') // dùng index theo 'date'      
        // .between(start, end, true, true)
        .toArray();
    const result = byDate.filter((msg: any) => msg.parseState === parseStatus)
        .filter((msg: any) => {
            let ok = messageType == 1 ? !msg.isOutgoing : (messageType == 2 ? msg.isOutgoing : true)
            if (ok) {
                ok = ok && !msg.text.startsWith('#')  // bỏ qua lệnh
            }
            if (ok) {
                ok = ok && !isTinKhop(msg.text)
            }
            return ok
        })
    const finalResult: LotMessage[] = []
    for (const msg of result) {
        const lmsg: LotMessage = {
            tlChatId: Number(msg.chatId),
            tlMessageId: msg.messageId,
            contactId: -1, //điền sau, dựa vào các tham số khác
            tlSenderId: Number(msg.senderId),
            body: msg.text,
            bodyOrigin: msg.text,
            date: secondsToDate(msg.date),
            type: msg.isOutgoing ? 2 : 1,
            htmlError: msg.text,
            errorText: "",
            tlChatTitle: msg.chatTitle
        }
        finalResult.push(lmsg)
    }
    return finalResult
}
function isTinKhop(text: string): boolean {
    const lowerText = text.toLowerCase();
    // tin khớp của bot
    if (lowerText.match(/^[^\p{L}\p{N}]*(?:[\w:]+)\s+.*\s+(mb|mt|mn)\s+nhận\s+[1-9][0-9]*\s+tin\.?$/u)) {
        return true;
    }
    // tin khớp của app android
    if (lowerText.match(/^nhan\s+\d+\s+tin\.so\s+tin\s+cuoi:\d+\.$/)) {
        return true;
    }
    // tin khớp bảng của 1 ngày từ android app
    if (lowerText.match(/^ngay:\d{1,2}\/\d{1,2}\/\d{4}[\s\S]*@\d+@$/)) {
        return true;
    }
    // là bot command dạng /command hoặc /command@botname
    if (lowerText.match(/^\/[a-zA-Z][a-zA-Z0-9_]*(@[a-zA-Z0-9_]+)?$/)) {
        return true;
    }
    return false;
}
export async function FetMessagesByChatAndSaveToLocal(chatId: string) {
    const db = await DBManager.getDBConnection()
    FetchMessagesByChatId(chatId, 0, -1, true).then((msgs: any) => {
        try {
            // đã lưu ở module message.ts khi fetchMessages, ở đây lưu khi đồng bộ
            const transMsgs = db.transaction(["messages"], "readwrite")
            const messages = transMsgs.objectStore("messages")
            if (msgs && msgs.messages && msgs.messages.length > 0) {
                msgs.messages.map((msg: any) => {
                    //msg.id = Math.floor(msg.id)
                    messages.put(msg)
                })
                console.log("Kết quả trả về:", msgs)
            }
            else {
                if (DEBUG)
                    console.log("Kết quả trả về không đúng cấu trúc:", msgs)
            }
            transMsgs.commit()
            //store.dispatch(updateNotiMessage({ message: `Đang đồng bộ hội thoại:${chatId}` }))
        }
        catch (e) {
            console.log(e);
        }
        const timer = setTimeout(() => {
            store.dispatch(clearMessages({}))
            if (DEBUG)
                console.log(`Đồng bộ xong toàn bộ tin nhắn:${chatId} `)
            clearTimeout(timer)
        }, 5000)
    })
}
export async function MarkAllmessagesNotParsed(): Promise<LotMessage[]> {
    let get = true
    let result: LotMessage[] = [];
    const db = await DBManager.getDBConnection()
    const trans = db.transaction("messages", "readwrite")
    const messagesStore = trans.objectStore("messages")
    const getRequest = messagesStore.getAll()
    const global = getGlobal()
    // Tạo một Promise để xử lý việc trả về
    const promise = new Promise<LotMessage[]>((resolve, reject) => {
        getRequest.onsuccess = () => {
            const existingMessages = getRequest.result;

            existingMessages.forEach((item) => {
                item.parsed = false;
                messagesStore.put(item)
            });

            // Giải phóng Promise khi đã xử lý xong
            resolve(result);
        };

        getRequest.onerror = () => {
            console.log("getRequest error");
            // Giải phóng Promise khi có lỗi
            reject("getRequest error");
        };
    });
    return promise;
}

export async function MarkMessageParsed(message: LotMessage, isAutoParse: boolean = false) {
    try {
        const userInfo = GetUserFullInfo()
        if (userInfo.suDungTinBot == enumDauVaoTinNhan.telegram) {
            const record = await globalDexieDb.telegramMessage
                .where('[chatId+messageId]')
                .equals([message.tlChatId, message.tlMessageId])
                .first()
            if (record) {
                record.parseState = MessageParseState.Parsed
                record.isAutoParse = isAutoParse
                await globalDexieDb.telegramMessage.put(record)
            }
            return
        } else {
            try {
                const parsedStore = (await DBManager.getDBConnection())
                    .transaction("messages", "readwrite")
                    .objectStore("messages")
                const key = [message.tlChatId + "", Number(message.tlMessageId)]
                const request = parsedStore.get(key)
                request.onsuccess = () => {
                    const msg = request.result
                    if (msg) {
                        msg.parsed = true;
                        msg.isAutoParse = isAutoParse
                        parsedStore.put(msg)
                    }
                }
            } catch (e) {
                console.log("Lỗi khi đánh dấu tin nhắn đã phân tích:", e)
            }
        }
    } catch (e) {
        console.log("Lỗi khi đánh dấu tin nhắn đã phân tích:", e)
    }
}
export async function MarkMessageAutoParsed(message: LotMessage, isAutoParse: boolean = false) {
    try {
        const parsedStore = (await DBManager.getDBConnection())
            .transaction("messages", "readwrite")
            .objectStore("messages")
        const key = [message.tlChatId + "", Number(message.tlMessageId)]
        const request = parsedStore.get(key)
        request.onsuccess = () => {
            const msg = request.result
            if (msg) {
                msg.isAutoParse = isAutoParse
                parsedStore.put(msg)
            }
        }
    } catch (e) {
        console.log("Lỗi khi đánh dấu tin nhắn tự động phân tích:", e)
    }

}
export async function IsMessageParsed(message: LotMessage) {
    const found = await globalDexieDb.messages.where("[chatId+id]")
        .equals([message.tlChatId + "", message.tlMessageId]).first()
    if (found) {
        if (found.parsed)
            return found.parsed == true
        else
            return false;
    }
    return false;
}
export async function IsMessageAutoParsed(message: LotMessage) {
    const found = await globalDexieDb.messages.where("[chatId+id]")
        .equals([message.tlChatId + "", message.tlMessageId]).first()
    if (found) {
        if (found.isAutoParse)
            return found.isAutoParse == true
        else
            return false;
    }
    return false;
}
export async function DeleteMessage(message: any) {
    const parsedStore = (await DBManager.getDBConnection())
        .transaction("messages", "readwrite")
        .objectStore("messages")
    const key = [message.tlChatId + "", Number(message.tlMessageId)]
    parsedStore.delete(key)
    Dexiedb.instance.telegramMessage.where('[chatId+messageId]').equals([Number( message.tlChatId), message.tlMessageId]).delete()
}
export async function deleteChatHistory(chatId: string) {
    // Lấy lịch sử tin nhắn bị sửa/xóa
    const global = getGlobal()
    let chat: ApiChat = selectChat(global, chatId) as ApiChat
    deleteHistory({ chat: chat, shouldDeleteForAll: true })
}
export async function GetChatListFromGlobal() {
    const user = await GetUserFullInfo()
    const result: ApiChat[] = []
    if (user.suDungTinBot == enumDauVaoTinNhan.bot) { // 1 là bot
        const result: ApiChat[] = store.getState().global.chats
        const tmp: ApiChat[] = []
        for (let chat of result) {
            const found = await globalDexieDb.messages.where("chatId").equals(chat.id).
                and(msg => {
                    let ok = false
                    if (msg.content.text && msg.content.text.text) {
                        ok = true
                        console.log(msg.content.text.text)
                    }
                    return ok
                }).last()

            if (found /* || userFullinfo.suDungTinBot == 1 */) {
                tmp.push(chat)
            }
        }
        return tmp
    } else if (user.suDungTinBot == enumDauVaoTinNhan.telegram) { //2 là user bot
        const result = (await globalDexieDb.chatSyncState.toArray()).
            filter(c => c.ownerId == user.username)
        return result.map(r => {
            const chat: ApiChat = { id: r.chatId.toString(), title: r.chatTitle, type: 'chatTypePrivate' } as ApiChat
            return chat as ApiChat
        })
    } else { //telegram login trong webapp 
        const chatIds = await GetChatIds()
        const global = getGlobal()

        chatIds?.map((chatId: string) => {
            const chat: ApiChat | undefined = selectChat(global, chatId)
            if (chat)
                result.push(chat)
        })
    }

    return result
}

export async function GetMessagesByChatId(chatId: string): Promise<ApiMessage[]> {
    const tmp: ApiMessage[] = []
    const userInfo = GetUserFullInfo()

    const promise = new Promise((resolve, reject) => {
        if (userInfo.suDungTinBot == enumDauVaoTinNhan.android) {
            DBManager.readDataByIndex("messages", chatId, "chatId").then(result => {
                result.map(msg => {
                    tmp.push(msg)
                })
                resolve(tmp);
            })
        } else if (userInfo.suDungTinBot == enumDauVaoTinNhan.telegram) {
            globalDexieDb.telegramMessage.where('chatId').equals(Number(chatId)).toArray().then(result => {
                result.map(msg => {
                    const apiMsg: ApiMessage = {
                        id: msg.messageId,
                        chatId: msg.chatId.toString(),
                        date: msg.date,
                        isOutgoing: msg.isOutgoing,
                        content: { text: { text: msg.text } }
                    }
                    tmp.push(apiMsg)
                })
                resolve(tmp);
            })
        } else if (userInfo.suDungTinBot == enumDauVaoTinNhan.bot) {
            globalDexieDb.messages.where('chatId').equals(chatId).toArray().then(result => {
                result.map(msg => {
                    tmp.push(msg)
                })
                resolve(tmp);
            })
        }
    })
    await promise
    return tmp
}
export async function LuuTrongTinNhan(messages: ApiMessage[], xoaTin?: boolean) {
    const ids: number[] = []
    messages.map((msg: ApiMessage) => {
        ids.push(Number(msg.chatId))
        ids.push(msg.id)
        const message: LotMessage = { tlMessageId: msg.id, tlChatId: Number(msg.chatId) }
        if (xoaTin) {
            DeleteMessage(message)
            //console.log(`xoá tin nhắn`)
        } else {
            //console.log(`đánh dấu đã phân tích để không nạp lên`)
            MarkMessageParsed(message)
        }
    })

    return Parser.deleteMessages(ids)
}

export function SendTeleMessage(message: string, chatId: string, sendMessage: Function): boolean {
    const userInfo = JSON.parse(localStorage['userFullInfo'])
    if (userInfo.suDungTinBot == enumDauVaoTinNhan.telegram) {
        // const wireMessage: WireMessage = {
        //     chat_id: Number(chatId),
        //     text: message,
        //     peer: chatId
        // }
        // const wsMessage: WSMessage = {
        //     kind: 'request',
        //     channel: 'telegram',
        //     action: 'send_message',
        //     data: wireMessage,
        // }
        // wsClientInstance.sendWireMessageViaWS(
        //     wsMessage
        // )
        const peer = "" + chatId
        gotdapi.sendMessage(peer, message)
    } else if (userInfo.suDungTinBot == enumDauVaoTinNhan.telegramweb) {


        if (chatId == '0') {
            console.log('chatId=0, không thể gửi tin nhắn');
            return false;
        }
        const { markMessageListRead } = getActions()
        const global = getGlobal()
        const { threadId } = selectCurrentMessageList(global) || {};
        const messageList: MessageList = {
            chatId: chatId,
            threadId: threadId || -1,
            type: 'thread'
        }
        let ok = false;
        if (message.trim() != "") {
            // hàm này import trong thâm FC mới được, do vây phải pass từ FC vào
            if (sendMessage) {
                sendMessage({ messageList: messageList, text: message })
                ok = true;
            }
            if (markMessageListRead != undefined) {
                //markMessageListRead({ chat:chatId, threadId:-1, maxId:0,})
                markMessageListRead({ maxId: 0, })
                ok = ok && true;
            }
            return ok
        }
        return false
    } else {
        console.log('Chức năng gửi tin nhắn cho user bot telegram chưa hỗ trợ');
        return false;

    }
}
// để khớp tin cho khách, chỉ lời gọi cuối cùng mới thực hiện send
//tránh trường hợp bomb tin trả lời 1 đống trong khi chỉ cần trả lời cái cuối cungf
export const DebounceSendTeleMessage = debounce((message: string, chatId: string, sendMessage: Function) => {

    SendTeleMessage(message, chatId, sendMessage)

}, 1000)
/**key: chatId(contact nhận tin khớp)*/
export const DebounceKhopTin = debounce(async (messages: Map<string, TeleMessageToSend>, sendMessage: Function) => {
    for (const [key, value] of messages) {
        const message = value.message
        const chatId = value.chatId
        SendTeleMessage(message, chatId, sendMessage)
        await sleep(100)
    }
}, 1000)